import { render, staticRenderFns } from "./SeleccionAsignacion.vue?vue&type=template&id=28b8fb92&scoped=true"
import script from "./SeleccionAsignacion.vue?vue&type=script&lang=js"
export * from "./SeleccionAsignacion.vue?vue&type=script&lang=js"
import style0 from "./SeleccionAsignacion.vue?vue&type=style&index=0&id=28b8fb92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b8fb92",
  null
  
)

export default component.exports